import React from "react";

const Item1 = () => {
  return (
    <section className="bg-gray-50 text-center py-16 px-6 md:px-20">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
          Where Stories Come to Life
        </h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          At <span className="font-semibold text-gray-900">StoneAge Films</span>
          , our work speaks louder than words. We’ve had the honor of
          collaborating with some of the world’s most innovative brands,
          creating powerful visuals that inspire, engage, and leave a lasting
          impression.
        </p>

        <p className="text-gray-700 leading-relaxed mb-12">
          Each project in our portfolio is a testament to our dedication to
          storytelling, creativity, and excellence. From high-impact commercials
          to dynamic digital campaigns, we bring every idea to life with
          precision and passion.
        </p>

        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
          Explore Our Portfolio
        </h3>

        <p className="text-gray-700 leading-relaxed">
          Dive into our collection of work and see how StoneAge Films has
          transformed bold ideas into unforgettable visuals.
        </p>
      </div>
    </section>
  );
};

export default Item1;
